'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249 from "./presto.-Two-Factor-Auth-View$$anon$9.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024 from "./presto.-Two-Factor-Auth-View$-Seed-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
  this.bK5 = null;
  this.bJX = null;
  this.bJY = false;
  this.bK6 = null;
  this.bK7 = false;
  this.bKa = null;
  this.bK3 = null;
  this.bK4 = false;
  this.bJZ = null;
  this.bK0 = false;
  this.bK1 = null;
  this.bK2 = false;
  this.bK8 = false;
  this.bK9 = false;
  this.bK5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bKa = "SeedToken";
}
export { $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $c_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$p = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$Tables$$anon$8;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$Tables$$anon$8() {
}
export { $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $h_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
$h_Lpresto_TwoFactorAuthView$Tables$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bK5;
});
$p.L = (function() {
  if ((!this.bJY)) {
    this.bJX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bJY = true;
  }
  return this.bJX;
});
$p.O = (function() {
  if ((!this.bK7)) {
    this.bK6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bK7 = true;
  }
  return this.bK6;
});
$p.E = (function() {
  return this.bKa;
});
$p.t = (function() {
  if ((!this.bK4)) {
    this.bK3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bK4 = true;
  }
  return this.bK3;
});
$p.M = (function() {
  if ((!this.bK0)) {
    this.bJZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bK0 = true;
  }
  return this.bJZ;
});
$p.Q = (function() {
  if ((!this.bK2)) {
    this.bK1 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00249.$c_Lpresto_TwoFactorAuthView$$anon$9();
    this.bK2 = true;
  }
  return this.bK1;
});
$p.w = (function() {
  if ((!this.bK9)) {
    this.bK8 = false;
    this.bK9 = true;
  }
  return this.bK8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee86) => ((p) => \u03b4scrutinee86.cGa(p)))($j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dSeed$002dToken$0024.$m_Lpresto_TwoFactorAuthView$SeedToken$())));
});
var $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$Tables$$anon$8, "presto.TwoFactorAuthView$Tables$$anon$8", ({
  TS: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 as $d_Lpresto_TwoFactorAuthView$Tables$$anon$8 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$-Tables$$anon$8.js.map
